import { CampaignCallout } from '@vp/campaign-callouts'
import { FlexBox, Callout } from '@vp/swan'
import { invalidCalloutTagTypes, MerchandisingTagType } from '../types/Callout'
import { CalloutType, ProductCallout } from './AutoGenerate/types/AutomatedExperience'

interface CalloutWrapperProps {
  callout?: ProductCallout | ProductCallout[]
  enableCampaignCallouts?: boolean
  mpvId?: string
}

export const CalloutWrapper = ({ callout, enableCampaignCallouts, mpvId }: CalloutWrapperProps) => {
  const isCalloutArray = Array.isArray(callout)

  return (
    <FlexBox flexDirection="column" gap="2">
      {isCalloutArray ? (
        (callout as ProductCallout[]).map((item, idx) => {
          if (item.type === CalloutType.CAMPAIGN && mpvId && enableCampaignCallouts) {
            return <CampaignCallout product={mpvId} key={idx} />
          }
          if (
            (item.type === CalloutType.OUT_OF_STOCK ||
              (item.type === CalloutType.TAG && !invalidCalloutTagTypes.includes(item.tagType as MerchandisingTagType))) &&
            item.value &&
            item.value !== '' &&
            item.skin &&
            (item.variant || item.emphasis)
          ) {
            return (
              <Callout
                skin={item.skin}
                variant={item.variant ?? null}
                emphasis={item.emphasis ?? null}
                style={{ width: 'fit-content' }}
                key={idx}
                data-testid="callout"
              >
                {item.value}
              </Callout>
            )
          }
          return null
        })
      ) : (
        <>
          {callout?.value &&
            callout?.value !== '' &&
            callout?.skin &&
            (callout?.variant || callout?.emphasis) &&
            !invalidCalloutTagTypes.includes(callout.tagType as MerchandisingTagType) && (
              <Callout
                skin={callout.skin}
                variant={callout.variant ?? null}
                emphasis={callout.emphasis ?? null}
                style={{ width: 'fit-content' }}
                data-testid="callout"
              >
                {callout.value}
              </Callout>
            )}
          {enableCampaignCallouts && <CampaignCallout product={mpvId ?? ''} />}
        </>
      )}
    </FlexBox>
  )
}
